import { useBreakpoints } from '@vueuse/core';
import { breakpoints as definedBreakpoints } from '@/styling/foundation/breakpoint';

export const breakpoints = useBreakpoints(definedBreakpoints);

export const isMobile = breakpoints.smaller('lg');
